import { Typography } from '@mui/material';

import { FHChip } from '../../../base';
import { ClaimStatusColor, ClaimStatusFontColor } from '../../billings/claim-info/constants';

import type { ClaimStatusType } from '../../billings/claim-info/constants';

export const claimHistoryColumns = [
  {
    name: 'id',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: ClaimStatusType) => {
        return (
          <FHChip
            sx={{ fontSize: '12px', fontWeight: '700', lineHeight: '18px', wordWrap: 'break-word' }}
            content={value}
            bgColor={ClaimStatusColor[value]}
            color={ClaimStatusFontColor[value]}
          />
        );
      },
    },
  },
  {
    name: 'secondary_status',
    label: 'Sec. Status',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: ClaimStatusType) => {
        return value ? (
          <FHChip
            sx={{ fontSize: '12px', fontWeight: '700', lineHeight: '18px', wordWrap: 'break-word' }}
            content={value}
            bgColor={ClaimStatusColor[value]}
            color={ClaimStatusFontColor[value]}
          />
        ) : (
          ''
        );
      },
    },
  },
  {
    name: 'recoupment_probability',
    label: 'Recoupment probability',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'recoupment_reason',
    label: 'Recoupment reason',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'client',
    label: 'Client',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'created_by',
    label: 'Created by',
    options: {
      filter: false,
      sort: true,
    },
  },

  {
    name: 'claim_id',
    label: 'Claim ID',
    options: {
      filter: false,
      sort: false,
    },
  },

  {
    name: 'clearing_house_claim_id',
    label: 'Clearinghouse ID',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'claimed_date',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
    },
  },
  {
    name: 'earliest_service_date',
    label: 'Earliest Service Date',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (value: ClaimStatusType) => {
        return <Typography textAlign={'center'}>{value}</Typography>;
      },
    },
  },
  {
    name: 'service_code_label',
    label: 'Service code',
    options: {
      filter: false,
      sort: false,
    },
  },
];
